<template>
  <Modal :value="show" :title="$t('title.w56')" :mask-closable="false" :footer-hide="true" @on-visible-change="change" :closable="validwarn.indexOf($route.name)==-1">
    <div>
      <div class="item i1">
        <b>{{$t('label.w24')}}</b>
        <span class="state" :class="{ok:safe.IdCardVerified===1}" @click="href(safe.IdCardVerified===1)">
          <span class="n">
            <Icon type="md-alert" color="#FFB43A" :size="18" /> {{$t('option.w16')}}
          </span>
          <span class="y">
            <Icon type="md-checkmark-circle" color="#00C86F" :size="18" /> {{$t('option.w17')}}
          </span>
        </span>
      </div>
      <div class="item i2">
        <b>{{$t('label.w117')}}</b>
        <span class="state" :class="{ok:safe.MobliePhoneVerified}" @click="href(safe.MobliePhoneVerified)">
          <span class="n">
            <Icon type="md-alert" color="#FFB43A" :size="18" /> {{$t('option.w16')}}
          </span>
          <span class="y">
            <Icon type="md-checkmark-circle" color="#00C86F" :size="18" /> {{$t('option.w17')}}
          </span>
        </span>
      </div>
      <div class="item i3">
        <b>{{$t('label.w118')}}</b>
        <span class="state" :class="{ok:safe.EmailVerified}" @click="href(safe.EmailVerified)">
          <span class="n">
            <Icon type="md-alert" color="#FFB43A" :size="18" /> {{$t('option.w16')}}
          </span>
          <span class="y">
            <Icon type="md-checkmark-circle" color="#00C86F" :size="18" /> {{$t('option.w17')}}
          </span>
        </span>
      </div>
    </div>
  </Modal>
</template>
<script>
import {validwarn} from '@/libs/sysconst'
export default {
  data() {
    return {
      closeable:false,
      validwarn,//不允许关闭的路由名称
    };
  },
  methods:{
    href(v){
      if(v) return;
      this.$store.commit('user/logidValid',false)
      this.$router.push({name:'security'})
    },
    change(v){
      if(v===false) this.$store.commit('user/logidValid',v)
    }
  },
  computed:{
    safe(){
      return this.$store.state.user.safe
    },
    show(){
      let c1=(
        this.safe.IdCardVerified===0||
        this.safe.IdCardVerified===2||
        this.safe.IdCardVerified===3||
        this.safe.MobliePhoneVerified===false||
        this.safe.EmailVerified===false
      )
      let c2=(
        this.$store.state.user.logidValid||
        this.validwarn.indexOf(this.$route.name)>-1
      )
      return c1&&c2
    }
  }
};
</script>
<style lang="less" scoped>
.item {
  margin-top: 10px;
  &:first-child{
    margin-top: 3px;
  }
  &:before {
    width: 32px;
    height: 32px;
    display: inline-block;
    vertical-align: middle;
    content: "";
    background: 50% no-repeat;
    background-size: contain;
    margin-right: 20px;
  }
  &.i1:before {
    background-image: url(../assets/borrow/pic_sf@2x.png);
  }
  &.i2:before {
    background-image: url(../assets/borrow/pic_mobile@2x.png);
  }
  &.i3:before {
    background-image: url(../assets/borrow/pic_email@2x.png);
  }
  b{
    display: inline-block;
    vertical-align: middle;
  }
  .state{
    display: inline-block;
    vertical-align: middle;
    float: right;
    padding:0 9px;
    height:26px;
    line-height: 25px;
    border-radius:4px;
    border:1px solid rgba(184,184,187,1);
    cursor: pointer;
    .y{display: none;}
    &.ok{
      cursor: default;
      border-color: #fff;
      .y{display: inline;}
      .n{display: none;}
    }
  }
}
</style>
